import { Link } from 'react-router-dom';
import { getElementTypeLabel } from '../../../constants/AssetTestConfig';
import Badge from '../../../components/ui/Badge';
import { useAuthStore } from '../../../store/authStore';
import { isOwnInProgressSession } from '../../../lib/sessionOwnership';

/**
 * The action for one in-progress session on a sites surface.
 *
 * `/sessions/in-progress` is org-wide, so this list includes jobs colleagues have open. Only the
 * owner may resume: resuming someone else's session would let two technicians write results into
 * one session, which is a deferred roadmap item, not this behaviour. Everyone else sees who has
 * the job and can start their own session at the site instead.
 *
 * Ownership is decided from `session.user_id` vs the logged-in user (see sessionOwnership.js),
 * not from the server's `is_mine` alone — that flag is personalized and can stick in a shared
 * React Query cache after a user switch.
 */
export default function SiteSessionAction({ session, siteId, size }) {
  const user = useAuthStore((s) => s.user);
  const typeLabel = getElementTypeLabel(session.element_type);

  if (!isOwnInProgressSession(session, user)) {
    return (
      <Badge variant="muted" className="site-session-owner">
        {typeLabel} · Started by {session.user_name || 'Unknown'}
      </Badge>
    );
  }

  return (
    <Link
      to="/tests"
      state={{ resumeSiteId: String(siteId), resumeSessionId: session.id }}
      className={`btn ${size === 'sm' ? 'btn-sm ' : ''}btn-primary site-test-action-btn`}
    >
      Resume {typeLabel}
    </Link>
  );
}
